import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=84d31ae4"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=84d31ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports